module.exports = __webpack_public_path__ + "static/ping-pong-d29a2a2ba09261d5892e15d3a83ed095.svg";